// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oy-9";
export var arrowButtonContainer = "_oy-5";
export var arrowButtonIcon = "_oy-6";
export var carouselArrowButton = "_oy-2";
export var carouselElementContainer = "_oy-1";
export var currentSlide = "_oy-8";
export var left = "_oy-3";
export var otherSlide = "_oy-a";
export var productCarouselContainer = "_oy-0";
export var right = "_oy-4";
export var sliderOverflow = "_oy-7";